import { render } from "./purchase-orders.vue?vue&type=template&id=3f22c1b4"
import script from "./purchase-orders.vue?vue&type=script&lang=js"
export * from "./purchase-orders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__